import { render } from "./CircularEconomyProjects.vue?vue&type=template&id=1b7aeb88"
import script from "./CircularEconomyProjects.vue?vue&type=script&lang=js"
export * from "./CircularEconomyProjects.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__